import { svg } from 'lit';

const symbol = svg`<svg width="10" height="13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 .03L0 6.06l4.185 1.645 1.304 5.265L10 .029z" fill="#E6E6E6"/></svg>`;

export { symbol as default };
